import { isUndefined } from 'lodash';

import type { NotificationPreferencesV2Type } from 'bundles/naptimejs/resources/notificationPreferences.v2';
import {
  CONSUMER_GRADIENTS,
  ENTERPRISE_GRADIENTS,
  UNSUBSCRIBED_PREFERENCE,
} from 'bundles/user-consent/constants/GdprConstants';

export const showBanner = (
  notificationPreferences?: NotificationPreferencesV2Type,
  isEnterprise = false,
  isAdmin = false
): boolean => {
  const shouldRenderConsumerBanner =
    !!notificationPreferences &&
    notificationPreferences.volunteer?.email === UNSUBSCRIBED_PREFERENCE &&
    notificationPreferences.promotions?.email === UNSUBSCRIBED_PREFERENCE &&
    notificationPreferences.recommendations?.email === UNSUBSCRIBED_PREFERENCE;
  const shouldRenderEnterpriseBanner =
    (!!notificationPreferences && isUndefined(notificationPreferences.enterpriseMarketing)) ||
    (!!notificationPreferences &&
      !!notificationPreferences.enterpriseMarketing &&
      notificationPreferences.enterpriseMarketing.email === UNSUBSCRIBED_PREFERENCE);

  /**
   * Scenarios when the GDPR Banner should be shown
   * 1. Enterprise + Admin gets notifications to keep their members on track
   * 2. Consumers get notifications to keep themselves on track
   *
   * Scenarios when the GDPR Banner should not be shown
   * 1. Enterprise consumers don't because we defer that to the administrators
   */
  if (isAdmin && isEnterprise) {
    return shouldRenderEnterpriseBanner;
  }
  if (!isAdmin && !isEnterprise) {
    return shouldRenderConsumerBanner;
  }
  return false;
};

export const getGradient = (isEnterprise = false, isAdmin = false) => {
  const gradientSrc = isEnterprise && isAdmin ? ENTERPRISE_GRADIENTS : CONSUMER_GRADIENTS;

  return gradientSrc[Math.floor(Math.random() * gradientSrc.length)];
};

type Gradient = {
  start: string;
  end: string;
  deg: number;
};

type GradientMap = {
  [key: string]: Gradient;
};

// This gradient group is temporarily copied from the coursera-ui codebase to remove the legacy import.
// TODO: We will replace it with a standardized color once color alignment is finalized.
export const gradient: GradientMap = {
  peach: {
    start: '#fc6e51',
    end: '#f6bb42',
    deg: 90,
  },
  pear: {
    start: '#ffce54',
    end: '#8cc152',
    deg: 90,
  },
  kiwi: {
    start: '#a0d468',
    end: '#37bc9b',
    deg: 90,
  },
  sea: {
    start: '#48cfad',
    end: '#3bafda',
    deg: 90,
  },
  coursera: {
    start: '#4fc1e9',
    end: '#4a89dc',
    deg: 90,
  },
  blueberry: {
    start: '#5d9cec',
    end: '#967adc',
    deg: 90,
  },
  grape: {
    start: '#ac92ec',
    end: '#d770ad',
    deg: 90,
  },
  lightBlue: {
    start: '#E3EEFF',
    end: '#89B3EF',
    deg: 90,
  },
};
